import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class ModalTrigger extends Component {
  render() {
     switch (this.props.type) {
        case 'denuncie':
            return (
               <button 
                  className="button button--side-nav button--denuncie" 
                  ref={this.props.buttonRef}
                  onClick={this.props.showModal}
               >
                  <span className="button__title"><FormattedMessage id="home.modal_situ.h1"/></span>
                  <span className="button__subtitle"><FormattedMessage id="home.modal_situ.h4"/></span>
               </button>
            )
         case 'vivenciadas':
            return (
               <button 
                  className="button button--side-nav button--vivenciadas" 
                  ref={this.props.buttonRef}
                  onClick={this.props.showModal}
               >
                  <span className="button__title"><FormattedMessage id="home.modal_vivenciadas.h1"/></span>
                  <span className="button__subtitle"><FormattedMessage id="home.modal_vivenciadas.h4"/></span>
               </button>
               )
         default:
     }
  }
}

export default ModalTrigger;
